import * as Dtos from "../dtos/Tmd.dtos";
import { IFormFilter } from "../reducers/index";

export const
    LoadLaboratoryPersonnels: ILaboratoryPersonnelsLoadActionCreator = () => {
        return {
            type: ACTION_LABORATORYPERSONNEL_LOAD
        }
    },
    LoadLaboratoryPersonnelById: ILaboratoryPersonnelLoadByIdActionCreator = (id) => {
        return {
            type: ACTION_LABORATORYPERSONNEL_LOAD_BY_ID,
            id
        }
    },
    LoadLaboratoryPersonnelByLaboratoryId: ILaboratoryPersonnelLoadByLaboratoryIdActionCreator = (laboratoryId) => {
        return {
            type: ACTION_LABORATORYPERSONNEL_LOAD_BY_LABORATORY_ID,
            laboratoryId
        }
    },
    LoadSuccess: ILaboratoryPersonnelLoadSuccessActionCreator = (formData, formState, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_LABORATORYPERSONNEL_LOAD_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups,
            responseStatus
        }
    },
    LoadFailure: ILaboratoryPersonnelLoadFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_LABORATORYPERSONNEL_LOAD_FAILURE,
            responseStatus
        }
    },

    SaveLaboratoryPersonnel: ILaboratoryPersonnelSaveActionCreator = (formData) => {
        return {
            type: ACTION_LABORATORYPERSONNEL_SAVE,
            formData
        }
    },
    SaveSuccess: ILaboratoryPersonnelSaveSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_LABORATORYPERSONNEL_SAVE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    SaveFailure: ILaboratoryPersonnelSaveFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_LABORATORYPERSONNEL_SAVE_FAILURE,
            responseStatus
        }
    },

    CreateLaboratoryPersonnel: ILaboratoryPersonnelCreateActionCreator = (laboratoryId) => {

        return {
            type: ACTION_LABORATORYPERSONNEL_CREATE,
            laboratoryId
        }
    },
    CreateSuccess: ILaboratoryPersonnelCreateSuccessActionCreator = (formData, formState, formProperties, lookups) => {
        return {
            type: ACTION_LABORATORYPERSONNEL_CREATE_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups
        }
    },
    CreateFailure: ILaboratoryPersonnelCreateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_LABORATORYPERSONNEL_CREATE_FAILURE,
            responseStatus
        }
    },

    ValidateLaboratoryPersonnel: ILaboratoryPersonnelValidateActionCreator = (formData) => {
        return {
            type: ACTION_LABORATORYPERSONNEL_VALIDATE,
            formData
        }
    },
    ValidateSuccess: ILaboratoryPersonnelValidateSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_LABORATORYPERSONNEL_VALIDATE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    ValidateFailure: ILaboratoryPersonnelValidateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_LABORATORYPERSONNEL_VALIDATE_FAILURE,
            responseStatus
        }
    },

    Clear: ILaboratoryPersonnelClearActionCreator = (propertiesToClear?) => {
        return {
            type: ACTION_LABORATORYPERSONNEL_CLEAR,
            propertiesToClear
        }
    },

    Filter: ILaboratoryPersonnelFilterActionCreator = (formFilter) => {
        return {
            type: ACTION_LABORATORYPERSONNEL_FILTER,
            formFilter
        }
    };



export const
    ACTION_LABORATORYPERSONNEL_LOAD = "ACTION_LABORATORYPERSONNEL_LOAD",
    ACTION_LABORATORYPERSONNEL_LOAD_BY_ID = "ACTION_LABORATORYPERSONNEL_LOAD_BY_ID",
    ACTION_LABORATORYPERSONNEL_LOAD_BY_LABORATORY_ID = "ACTION_LABORATORYPERSONNEL_LOAD_BY_LABORATORY_ID",
    ACTION_LABORATORYPERSONNEL_LOAD_SUCCESS = "ACTION_LABORATORYPERSONNEL_LOAD_SUCCESS",
    ACTION_LABORATORYPERSONNEL_LOAD_FAILURE = "ACTION_LABORATORYPERSONNEL_LOAD_FAILURE",

    ACTION_LABORATORYPERSONNEL_SAVE = "ACTION_LABORATORYPERSONNEL_SAVE",
    ACTION_LABORATORYPERSONNEL_SAVE_SUCCESS = "ACTION_LABORATORYPERSONNEL_SAVE_SUCCESS",
    ACTION_LABORATORYPERSONNEL_SAVE_FAILURE = "ACTION_LABORATORYPERSONNEL_SAVE_FAILURE",

    ACTION_LABORATORYPERSONNEL_CREATE = "ACTION_LABORATORYPERSONNEL_CREATE",
    ACTION_LABORATORYPERSONNEL_CREATE_SUCCESS = "ACTION_LABORATORYPERSONNEL_CREATE_SUCCESS",
    ACTION_LABORATORYPERSONNEL_CREATE_FAILURE = "ACTION_LABORATORYPERSONNEL_CREATE_FAILURE",

    ACTION_LABORATORYPERSONNEL_VALIDATE = "ACTION_LABORATORYPERSONNEL_VALIDATE",
    ACTION_LABORATORYPERSONNEL_VALIDATE_SUCCESS = "ACTION_LABORATORYPERSONNEL_VALIDATE_SUCCESS",
    ACTION_LABORATORYPERSONNEL_VALIDATE_FAILURE = "ACTION_LABORATORYPERSONNEL_VALIDATE_FAILURE",

    ACTION_LABORATORYPERSONNEL_CLEAR = "ACTION_LABORATORYPERSONNEL_CLEAR",

    ACTION_LABORATORYPERSONNEL_FILTER = "ACTION_LABORATORYPERSONNEL_FILTER";

export interface ILaboratoryPersonnelsLoadAction {
    type: "ACTION_LABORATORYPERSONNEL_LOAD";
}

export interface ILaboratoryPersonnelsLoadActionCreator {
    (): ILaboratoryPersonnelsLoadAction;
}

export interface ILaboratoryPersonnelLoadSuccessAction {
    type: "ACTION_LABORATORYPERSONNEL_LOAD_SUCCESS";
    formData: Dtos.LaboratoryPersonnel | Dtos.LaboratoryPersonnel[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus;
}

export interface ILaboratoryPersonnelLoadSuccessActionCreator {
    (
        formData: Dtos.LaboratoryPersonnel | Dtos.LaboratoryPersonnel[],
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): ILaboratoryPersonnelLoadSuccessAction;
}

export interface ILaboratoryPersonnelLoadFailureAction {
    type: "ACTION_LABORATORYPERSONNEL_LOAD_FAILURE";
    responseStatus: Dtos.ResponseStatus;
}

export interface ILaboratoryPersonnelLoadFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ILaboratoryPersonnelLoadFailureAction;
}

export interface ILaboratoryPersonnelLoadByIdAction {
    type: "ACTION_LABORATORYPERSONNEL_LOAD_BY_ID";
    id: number;
}

export interface ILaboratoryPersonnelLoadByIdActionCreator {
    (id: number): ILaboratoryPersonnelLoadByIdAction;
}

export interface ILaboratoryPersonnelLoadByLaboratoryIdAction {
    type: "ACTION_LABORATORYPERSONNEL_LOAD_BY_LABORATORY_ID";
    laboratoryId: number;
}

export interface ILaboratoryPersonnelLoadByLaboratoryIdActionCreator {
    (laboratoryId: number): ILaboratoryPersonnelLoadByLaboratoryIdAction;
}

export interface ILaboratoryPersonnelSaveAction {
    type: "ACTION_LABORATORYPERSONNEL_SAVE";
    formData: Dtos.LaboratoryPersonnel;

}

export interface ILaboratoryPersonnelSaveActionCreator {
    (
        formData: Dtos.LaboratoryPersonnel
    ): ILaboratoryPersonnelSaveAction;
}

export interface ILaboratoryPersonnelSaveSuccessAction {
    type: "ACTION_LABORATORYPERSONNEL_SAVE_SUCCESS";
    formData: Dtos.LaboratoryPersonnel;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface ILaboratoryPersonnelSaveSuccessActionCreator {
    (
        formData: Dtos.LaboratoryPersonnel,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): ILaboratoryPersonnelSaveSuccessAction;
}

export interface ILaboratoryPersonnelSaveFailureAction {
    type: "ACTION_LABORATORYPERSONNEL_SAVE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ILaboratoryPersonnelSaveFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ILaboratoryPersonnelSaveFailureAction;
}

export interface ILaboratoryPersonnelCreateAction {
    type: "ACTION_LABORATORYPERSONNEL_CREATE";
    laboratoryId: number;
}

export interface ILaboratoryPersonnelCreateActionCreator {
    (laboratoryId: number): ILaboratoryPersonnelCreateAction
}

export interface ILaboratoryPersonnelCreateSuccessAction {
    type: "ACTION_LABORATORYPERSONNEL_CREATE_SUCCESS";
    formData: Dtos.LaboratoryPersonnel;
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[]
}

export interface ILaboratoryPersonnelCreateSuccessActionCreator {
    (
        formData: Dtos.LaboratoryPersonnel,
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[]
    ): ILaboratoryPersonnelCreateSuccessAction;
}

export interface ILaboratoryPersonnelCreateFailureAction {
    type: "ACTION_LABORATORYPERSONNEL_CREATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ILaboratoryPersonnelCreateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ILaboratoryPersonnelCreateFailureAction;
}

export interface ILaboratoryPersonnelValidateAction {
    type: "ACTION_LABORATORYPERSONNEL_VALIDATE";
    formData: Dtos.LaboratoryPersonnel;

}

export interface ILaboratoryPersonnelValidateActionCreator {
    (
        formData: Dtos.LaboratoryPersonnel
    ): ILaboratoryPersonnelValidateAction;
}

export interface ILaboratoryPersonnelValidateSuccessAction {
    type: "ACTION_LABORATORYPERSONNEL_VALIDATE_SUCCESS";
    formData: Dtos.LaboratoryPersonnel;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface ILaboratoryPersonnelValidateSuccessActionCreator {
    (
        formData: Dtos.LaboratoryPersonnel,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): ILaboratoryPersonnelValidateSuccessAction;
}

export interface ILaboratoryPersonnelValidateFailureAction {
    type: "ACTION_LABORATORYPERSONNEL_VALIDATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ILaboratoryPersonnelValidateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ILaboratoryPersonnelValidateFailureAction;
}

export interface ILaboratoryPersonnelClearAction {
    type: "ACTION_LABORATORYPERSONNEL_CLEAR";
    propertiesToClear?: string[];
}

export interface ILaboratoryPersonnelClearActionCreator {
    (propertiesToClear?: string[]): ILaboratoryPersonnelClearAction;
}

export interface ILaboratoryPersonnelFilterActionCreator {
    (formFilter: IFormFilter): ILaboratoryPersonnelFilterAction;
}

export interface ILaboratoryPersonnelFilterAction {
    type: "ACTION_LABORATORYPERSONNEL_FILTER";
    formFilter: IFormFilter;
}

export type LaboratoryPersonnelAction =
    ILaboratoryPersonnelsLoadAction |
    ILaboratoryPersonnelLoadByIdAction |
    ILaboratoryPersonnelLoadByLaboratoryIdAction |
    ILaboratoryPersonnelLoadFailureAction |
    ILaboratoryPersonnelLoadSuccessAction |
    ILaboratoryPersonnelSaveAction |
    ILaboratoryPersonnelSaveSuccessAction |
    ILaboratoryPersonnelSaveFailureAction |
    ILaboratoryPersonnelCreateAction |
    ILaboratoryPersonnelCreateSuccessAction |
    ILaboratoryPersonnelCreateFailureAction |
    ILaboratoryPersonnelValidateAction |
    ILaboratoryPersonnelValidateSuccessAction |
    ILaboratoryPersonnelValidateFailureAction |
    ILaboratoryPersonnelClearAction |
    ILaboratoryPersonnelFilterAction;
